// generate token with characters A-Z, a-z, 0-9

const tokenGenerator = (length = 0) => {
  const possibleValues =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
  let token = '';
  while (token.length < length)
    token += possibleValues.charAt(
      Math.floor(Math.random() * possibleValues.length)
    );
  return token;
};

export default tokenGenerator;
